import React from "react";
import { useLocation } from "react-router-dom";
import HomeComponent from './UserB/HomeComponent';

const Home: React.FC = () => {
  const { key } = useLocation();
  return <HomeComponent key={key} />;
};

export default Home;
